<template>
  <div>
    <div class="input-group">
      <div class="form-floating">
        <input
            @input="handleInput"
            type="text"
            class="form-control"
            :id="property"
            :value="value"
            placeholder="name@example.com"
            :class="{ 'is-invalid': error }"
            :disabled="disabled"
        >
        <label :for="property">{{ name }} <span class="text-danger" v-if="isRequired">*</span> </label>
      </div>
      <span class="input-group-text"> {{ prefix }}</span>
    </div>
    <div class="mb-3">
      <message-error :code="errorCode" :hasError="error"/>
    </div>
  </div>
  
</template>

<script>
import MessageError from '@/core/components/MessageError.vue'

export default {
  name: 'PriceField',
  components: { MessageError },
  props: {
    value:{}, 
    property:{}, 
    name:{}, 
    error:{}, 
    prefix:{ default: '€'},
    disabled:{ default: false},
    isRequired: {},
    errorCode: { type: String }
  },
  methods: {
    handleInput (e) {
      this.$emit('input', e.target.value)
    }
  }
}
</script>

<style scoped>
input{
  border-radius: 0 !important;
}
</style>
